@if (currentItem) {
<div class="active-item">
  <ng-container
    *ngTemplateOutlet="
      slideTpl;
      context: { item: currentItem, index: currentIndex }
    "
  ></ng-container>
</div>
} @if (showControls && items?.length > 1) {
<div class="controls my-1">
  <button
    class="btn btn-light btn-round mx-2"
    [class.disabled]="!isPreviousEnabled()"
    [disabled]="!isPreviousEnabled()"
    data-e2e="control-prev"
    (click)="selectPrevious($event)"
  >
    <fa-icon [icon]="['fas', 'angle-left']"></fa-icon>
  </button>
  <button
    class="btn btn-light btn-round mx-2"
    [class.disabled]="!isNextEnabled()"
    [disabled]="!isNextEnabled()"
    (click)="selectNext($event)"
    data-e2e="control-next"
  >
    <fa-icon [icon]="['fas', 'angle-right']"></fa-icon>
  </button>
</div>
}
